import { z } from 'zod';

export const addressSchema = z.object({
    street: z
        .string()
        .trim()
        .min(1, 'Street address is required')
        .min(2, 'Street address must be at least 2 characters')
        .max(255, 'Street address is too long'),

    city: z
        .string()
        .trim()
        .min(1, 'City is required')
        .min(2, 'City name must be at least 2 characters')
        .max(100, 'City name is too long'),

    state: z
        .string()
        .trim()
        .min(1, 'State/Province is required')
        .min(2, 'State/Province must be at least 2 characters')
        .max(100, 'State/Province name is too long'),

    postal_code: z
        .string()
        .trim()
        .min(1, 'Zip/Postal code is required')
        .min(2, 'Zip/Postal code must be at least 2 characters')
        .max(20, 'Zip/Postal code is too long'),

    country: z
        .string()
        .trim()
        .min(1, 'Country is required')
        .min(2, 'Country name must be at least 2 characters')
        .max(100, 'Country name is too long'),
});

export type AddressFormData = z.infer<typeof addressSchema>;
